import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useConceptGroups } from '../hooks/useConceptGroups';

export const ConceptGroupsGrid = () => {
  const { columns, getRowId, useFetchDataGridData } = useConceptGroups();

  return (
    <DataGridLayout id="concept-groups-list-content">
      <DataGrid
        id="concept-groups-grid"
        mode="client"
        getRowId={getRowId}
        columns={columns}
        useFetchDataGridData={useFetchDataGridData}
        onCellClick={() => {
          // TODO: @jason.ko - Implement on cell click for concept group view
        }}
      />
    </DataGridLayout>
  );
};
